import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute.jsx';
import AppShell from '../components/AppShell.jsx';
import PlusLauncher from './PlusLauncher.jsx';
// Phase 1 — Recruiting (ATS) + Onboarding & Journeys.
import RecruitingShell from './recruiting/RecruitingShell.jsx';
import Requisitions from './recruiting/pages/Requisitions.jsx';
import RequisitionDetail from './recruiting/pages/RequisitionDetail.jsx';
import Pipeline from './recruiting/pages/Pipeline.jsx';
import Candidates from './recruiting/pages/Candidates.jsx';
import Interviews from './recruiting/pages/Interviews.jsx';
import Offers from './recruiting/pages/Offers.jsx';
import Journeys from './recruiting/pages/Journeys.jsx';
import JourneyDetail from './recruiting/pages/JourneyDetail.jsx';
import Templates from './recruiting/pages/Templates.jsx';
// Phase 2 — Compensation Management.
import CompensationShell from './compensation/CompensationShell.jsx';
import CompCycles from './compensation/pages/Cycles.jsx';
import CompWorksheet from './compensation/pages/Worksheet.jsx';
import CompAwards from './compensation/pages/Awards.jsx';
import CompGrades from './compensation/pages/Grades.jsx';
import CompPlans from './compensation/pages/Plans.jsx';
import CompStatements from './compensation/pages/Statements.jsx';
// Phase 3 — Benefits Administration.
import BenefitsShell from './benefits/BenefitsShell.jsx';
import BenefitsPlans from './benefits/pages/Plans.jsx';
import BenefitsEligibility from './benefits/pages/EligibilityRules.jsx';
import BenefitsWindows from './benefits/pages/EnrollmentWindows.jsx';
import BenefitsWizard from './benefits/pages/EnrollmentWizard.jsx';
import BenefitsDependents from './benefits/pages/Dependents.jsx';
import BenefitsLifeEvents from './benefits/pages/LifeEvents.jsx';
import BenefitsDeductions from './benefits/pages/DeductionPreview.jsx';
// Phase 4 — Talent, Calibration, Succession & Skills Cloud.
import TalentShell from './talent/TalentShell.jsx';
import TalentGoals from './talent/pages/Goals.jsx';
import TalentSkills from './talent/pages/Skills.jsx';
import TalentSkillGap from './talent/pages/SkillGap.jsx';
import TalentCalibration from './talent/pages/Calibration.jsx';
import TalentCalibrationDetail from './talent/pages/CalibrationDetail.jsx';
import TalentSuccession from './talent/pages/Succession.jsx';
import TalentPools from './talent/pages/Pools.jsx';
// Phase 5 — Learning Management (LMS).
import LearningShell from './learning/LearningShell.jsx';
import LearningCatalog from './learning/pages/Catalog.jsx';
import LearningCourseDetail from './learning/pages/CourseDetail.jsx';
import LearningPaths from './learning/pages/Paths.jsx';
import LearningMyLearning from './learning/pages/MyLearning.jsx';
import LearningCertifications from './learning/pages/Certifications.jsx';
import LearningCompliance from './learning/pages/Compliance.jsx';
// Phase 6 — Advanced Time Tracking & Absence / Accruals.
import TimeShell from './time/TimeShell.jsx';
import TimeSchedules from './time/pages/SchedulesPage.jsx';
import TimeTimesheets from './time/pages/TimesheetsPage.jsx';
import TimeTimesheetDetail from './time/pages/TimesheetDetailPage.jsx';
import AbsenceShell from './absence/AbsenceShell.jsx';
import AbsencePlans from './absence/pages/PlansPage.jsx';
import AbsencePolicies from './absence/pages/PoliciesPage.jsx';
import AbsenceBalances from './absence/pages/BalancesPage.jsx';
import AbsenceRequests from './absence/pages/RequestsPage.jsx';
// Phase 7 — Global Payroll & Localization.
import PayrollGlobalShell from './payroll-global/PayrollGlobalShell.jsx';
import PayrollGlobalRuns from './payroll-global/pages/RunsPage.jsx';
import PayrollGlobalRunDetail from './payroll-global/pages/RunDetailPage.jsx';
import PayrollGlobalPayGroups from './payroll-global/pages/PayGroupsPage.jsx';
import PayrollGlobalComponents from './payroll-global/pages/ComponentsPage.jsx';
import PayrollGlobalJurisdictions from './payroll-global/pages/JurisdictionsPage.jsx';
// Phase 8 — Expense Management.
import ExpenseShell from './expenses/ExpenseShell.jsx';
import ExpenseReports from './expenses/pages/ReportsPage.jsx';
import ExpenseReportDetail from './expenses/pages/ReportDetailPage.jsx';
import ExpenseApprovals from './expenses/pages/ApprovalsPage.jsx';
import ExpenseCards from './expenses/pages/CardsPage.jsx';
import ExpensePolicies from './expenses/pages/PoliciesPage.jsx';
// Phase 9 — Multi-Entity, Consolidation & Revenue Recognition.
import EntitiesShell from './entities/EntitiesShell.jsx';
import EntityTree from './entities/pages/EntityTreePage.jsx';
import Currencies from './entities/pages/CurrenciesPage.jsx';
import FxRates from './entities/pages/FxRatesPage.jsx';
import Intercompany from './entities/pages/IntercompanyPage.jsx';
import Consolidation from './entities/pages/ConsolidationPage.jsx';
import RevRecShell from './revrec/RevRecShell.jsx';
import RevRecContracts from './revrec/pages/ContractsPage.jsx';
import RevRecObligations from './revrec/pages/ObligationsPage.jsx';
import RevRecSchedules from './revrec/pages/SchedulesPage.jsx';
// Phase 10 — Adaptive Planning / FP&A.
import PlanningShell from './planning/PlanningShell.jsx';
import PlanningModels from './planning/pages/ModelsPage.jsx';
import PlanningGrid from './planning/pages/PlanningGridPage.jsx';
import PlanningScenarios from './planning/pages/ScenarioComparePage.jsx';
import PlanningForecast from './planning/pages/ForecastPage.jsx';
import PlanningWorkforce from './planning/pages/WorkforcePlanPage.jsx';
import PlanningVariance from './planning/pages/VariancePage.jsx';
// Phase 11 — Contingent Workforce / VMS + Strategic Sourcing.
import VmsShell from './vms/VmsShell.jsx';
import VmsWorkers from './vms/pages/WorkersPage.jsx';
import VmsSow from './vms/pages/SowPage.jsx';
import VmsTimecards from './vms/pages/TimecardsPage.jsx';
import VmsQualifications from './vms/pages/QualificationsPage.jsx';
import SourcingShell from './sourcing/SourcingShell.jsx';
import SourcingEvents from './sourcing/pages/EventsPage.jsx';
import SourcingWorkspace from './sourcing/pages/EventWorkspacePage.jsx';
// Phase 12 — Configurable Business Process & Security Framework.
import BpShell from './bp/BpShell.jsx';
import BpDefinitions from './bp/pages/DefinitionsPage.jsx';
import BpBuilder from './bp/pages/ProcessBuilderPage.jsx';
import BpDelegations from './bp/pages/DelegationsPage.jsx';
import BpRuns from './bp/pages/RunsPage.jsx';
import SecurityShell from './security/SecurityShell.jsx';
import SecurityPolicies from './security/pages/PoliciesPage.jsx';
import SecurityExplain from './security/pages/ExplainPage.jsx';
// Phase 13 — AI Intelligence + Prism Analytics.
import PrismShell from './prism/PrismShell.jsx';
import PrismMarts from './prism/pages/MartsPage.jsx';
import IntelligenceShell from './intelligence/IntelligenceShell.jsx';
import IntelInsights from './intelligence/pages/InsightsPage.jsx';
import IntelAsk from './intelligence/pages/AskPage.jsx';
// Phase 14a — Messenger (entity-attached conversation threads).
import MessengerShell from './messenger/MessengerShell.jsx';

/**
 * BOS+ expansion (additive) — the single frontend route aggregator.
 *
 * `App.jsx` renders this ONCE inside its `<Routes>` by CALLING it as a function
 * — `{PlusRoutes()}` — so the returned `React.Fragment`'s `<Route>` children
 * become direct children of `<Routes>`. (react-router-dom v6.27's `<Routes>`
 * flattens `<React.Fragment>` children into route definitions; rendering
 * `<PlusRoutes/>` as an element instead would be rejected, hence the call form.)
 *
 * Append-only: each later phase adds its `<Route>` block inside the delimited
 * region below, mirroring the nested-route style in `App.jsx`. Never reorder.
 */
export default function PlusRoutes() {
  return (
    <>
      <Route
        path="/plus"
        element={
          <ProtectedRoute>
            <PlusLauncher />
          </ProtectedRoute>
        }
      />
      {/* ===== plus modules (append new <Route> blocks below; do not reorder) ===== */}

      {/* Phase 1 — Recruiting (ATS) + Onboarding & Journeys. */}
      <Route
        path="/recruiting"
        element={
          <ProtectedRoute resource="job_requisition" action="list">
            <RecruitingShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/recruiting/requisitions" replace />} />
        <Route path="requisitions" element={<Requisitions />} />
        <Route path="requisitions/:id" element={<RequisitionDetail />} />
        <Route path="requisitions/:id/pipeline" element={<Pipeline />} />
        <Route path="candidates" element={<Candidates />} />
        <Route path="interviews" element={<Interviews />} />
        <Route path="offers" element={<Offers />} />
        <Route path="onboarding" element={<Journeys />} />
        <Route path="onboarding/:id" element={<JourneyDetail />} />
        <Route path="templates" element={<Templates />} />
      </Route>

      {/* Phase 2 — Compensation Management (additive). */}
      <Route
        path="/compensation"
        element={
          <ProtectedRoute resource="comp_cycle" action="list">
            <CompensationShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/compensation/cycles" replace />} />
        <Route path="cycles" element={<CompCycles />} />
        <Route path="cycles/:id/worksheet" element={<CompWorksheet />} />
        <Route path="awards" element={<CompAwards />} />
        <Route path="grades" element={<CompGrades />} />
        <Route path="plans" element={<CompPlans />} />
        <Route path="statements" element={<CompStatements />} />
      </Route>

      {/* Phase 3 — Benefits Administration (additive). */}
      <Route
        path="/benefits"
        element={
          <ProtectedRoute resource="benefit_plan" action="list">
            <BenefitsShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/benefits/plans" replace />} />
        <Route path="plans" element={<BenefitsPlans />} />
        <Route path="eligibility" element={<BenefitsEligibility />} />
        <Route path="windows" element={<BenefitsWindows />} />
        <Route path="enroll" element={<BenefitsWizard />} />
        <Route path="dependents" element={<BenefitsDependents />} />
        <Route path="life-events" element={<BenefitsLifeEvents />} />
        <Route path="deductions" element={<BenefitsDeductions />} />
      </Route>

      {/* Phase 4 — Talent, Calibration, Succession & Skills Cloud (additive). */}
      <Route
        path="/talent"
        element={
          <ProtectedRoute resource="talent_goal" action="list">
            <TalentShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/talent/goals" replace />} />
        <Route path="goals" element={<TalentGoals />} />
        <Route path="skills" element={<TalentSkills />} />
        <Route path="gap" element={<TalentSkillGap />} />
        <Route path="calibration" element={<TalentCalibration />} />
        <Route path="calibration/:id" element={<TalentCalibrationDetail />} />
        <Route path="succession" element={<TalentSuccession />} />
        <Route path="pools" element={<TalentPools />} />
      </Route>

      {/* Phase 5 — Learning Management (LMS) (additive). */}
      <Route
        path="/learning"
        element={
          <ProtectedRoute resource="learning_course" action="list">
            <LearningShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/learning/catalog" replace />} />
        <Route path="catalog" element={<LearningCatalog />} />
        <Route path="catalog/:id" element={<LearningCourseDetail />} />
        <Route path="paths" element={<LearningPaths />} />
        <Route path="my-learning" element={<LearningMyLearning />} />
        <Route path="certifications" element={<LearningCertifications />} />
        <Route path="compliance" element={<LearningCompliance />} />
      </Route>

      {/* Phase 6 — Advanced Time Tracking (additive). */}
      <Route
        path="/time"
        element={
          <ProtectedRoute resource="timesheet" action="list">
            <TimeShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/time/timesheets" replace />} />
        <Route path="timesheets" element={<TimeTimesheets />} />
        <Route path="timesheets/:id" element={<TimeTimesheetDetail />} />
        <Route path="schedules" element={<TimeSchedules />} />
      </Route>

      {/* Phase 6 — Absence & Accruals (additive). */}
      <Route
        path="/absence"
        element={
          <ProtectedRoute resource="absence_plan" action="list">
            <AbsenceShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/absence/balances" replace />} />
        <Route path="balances" element={<AbsenceBalances />} />
        <Route path="requests" element={<AbsenceRequests />} />
        <Route path="plans" element={<AbsencePlans />} />
        <Route path="policies" element={<AbsencePolicies />} />
      </Route>

      {/* Phase 7 — Global Payroll & Localization (additive). */}
      <Route
        path="/payroll-global"
        element={
          <ProtectedRoute resource="payrollx_run" action="list">
            <PayrollGlobalShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/payroll-global/runs" replace />} />
        <Route path="runs" element={<PayrollGlobalRuns />} />
        <Route path="runs/:id" element={<PayrollGlobalRunDetail />} />
        <Route path="pay-groups" element={<PayrollGlobalPayGroups />} />
        <Route path="components" element={<PayrollGlobalComponents />} />
        <Route path="jurisdictions" element={<PayrollGlobalJurisdictions />} />
      </Route>

      {/* Phase 8 — Expense Management (additive). */}
      <Route
        path="/expenses"
        element={
          <ProtectedRoute resource="expense_report" action="list">
            <ExpenseShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/expenses/reports" replace />} />
        <Route path="reports" element={<ExpenseReports />} />
        <Route path="reports/:id" element={<ExpenseReportDetail />} />
        <Route path="approvals" element={<ExpenseApprovals />} />
        <Route path="cards" element={<ExpenseCards />} />
        <Route path="policies" element={<ExpensePolicies />} />
      </Route>

      {/* Phase 9 — Multi-Entity & Consolidation (additive). */}
      <Route
        path="/entities"
        element={
          <ProtectedRoute resource="legal_entity" action="list">
            <EntitiesShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/entities/entity-tree" replace />} />
        <Route path="entity-tree" element={<EntityTree />} />
        <Route path="currencies" element={<Currencies />} />
        <Route path="fx-rates" element={<FxRates />} />
        <Route path="intercompany" element={<Intercompany />} />
        <Route path="consolidation" element={<Consolidation />} />
      </Route>

      {/* Phase 9 — Revenue Recognition (additive). */}
      <Route
        path="/revrec"
        element={
          <ProtectedRoute resource="revrec_contract" action="list">
            <RevRecShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/revrec/contracts" replace />} />
        <Route path="contracts" element={<RevRecContracts />} />
        <Route path="obligations" element={<RevRecObligations />} />
        <Route path="schedules" element={<RevRecSchedules />} />
      </Route>

      {/* Phase 10 — Adaptive Planning / FP&A (additive). */}
      <Route
        path="/planning"
        element={
          <ProtectedRoute resource="plan_model" action="list">
            <PlanningShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/planning/models" replace />} />
        <Route path="models"    element={<PlanningModels />} />
        <Route path="grid"      element={<PlanningGrid />} />
        <Route path="scenarios" element={<PlanningScenarios />} />
        <Route path="forecast"  element={<PlanningForecast />} />
        <Route path="workforce" element={<PlanningWorkforce />} />
        <Route path="variance"  element={<PlanningVariance />} />
      </Route>

      {/* Phase 11 — Contingent Workforce / VMS (additive). */}
      <Route path="/vms" element={<ProtectedRoute resource="contingent_worker" action="list"><VmsShell /></ProtectedRoute>}>
        <Route index element={<Navigate to="/vms/workers" replace />} />
        <Route path="workers" element={<VmsWorkers />} />
        <Route path="sow" element={<VmsSow />} />
        <Route path="timecards" element={<VmsTimecards />} />
        <Route path="qualifications" element={<VmsQualifications />} />
      </Route>

      {/* Phase 11 — Strategic Sourcing / RFx (additive). */}
      <Route path="/sourcing" element={<ProtectedRoute resource="sourcing_event" action="list"><SourcingShell /></ProtectedRoute>}>
        <Route index element={<Navigate to="/sourcing/events" replace />} />
        <Route path="events" element={<SourcingEvents />} />
        <Route path="events/:id" element={<SourcingWorkspace />} />
      </Route>

      {/* Phase 12 — Configurable Business Process (additive). */}
      <Route path="/bp" element={<ProtectedRoute resource="bp_definition" action="list"><BpShell /></ProtectedRoute>}>
        <Route index element={<Navigate to="/bp/definitions" replace />} />
        <Route path="definitions" element={<BpDefinitions />} />
        <Route path="definitions/:id" element={<BpBuilder />} />
        <Route path="delegations" element={<BpDelegations />} />
        <Route path="runs" element={<BpRuns />} />
      </Route>

      {/* Phase 12 — Security Policies (additive). */}
      <Route path="/security-policies" element={<ProtectedRoute resource="security_policy" action="list"><SecurityShell /></ProtectedRoute>}>
        <Route index element={<Navigate to="/security-policies/policies" replace />} />
        <Route path="policies" element={<SecurityPolicies />} />
        <Route path="explain" element={<SecurityExplain />} />
      </Route>

      {/* Phase 13 — Prism Analytics (additive). */}
      <Route path="/prism" element={<ProtectedRoute resource="data_mart" action="list"><PrismShell /></ProtectedRoute>}>
        <Route index element={<Navigate to="/prism/marts" replace />} />
        <Route path="marts" element={<PrismMarts />} />
      </Route>

      {/* Phase 13 — AI Intelligence (additive). */}
      <Route path="/intelligence" element={<ProtectedRoute resource="recommendation" action="list"><IntelligenceShell /></ProtectedRoute>}>
        <Route index element={<Navigate to="/intelligence/insights" replace />} />
        <Route path="insights" element={<IntelInsights />} />
        <Route path="ask" element={<IntelAsk />} />
      </Route>

      {/* Phase 14a — Messenger (entity-attached conversation threads). */}
      <Route element={<ProtectedRoute resource="messenger_thread" action="read"><AppShell flush /></ProtectedRoute>}>
        <Route path="/messenger" element={<MessengerShell />} />
      </Route>

      {/* ===== end plus modules ===== */}
    </>
  );
}
